import { useEffect } from 'react';
import { scrollToSection } from '../lib/scroll';

/**
 * The browser jumps to a URL fragment while the document is still the empty
 * React root, so a shared link such as `/#visit` used to land on the hero.
 * Once the sections exist, aim at the fragment the same way the nav does.
 */
export function useInitialHashScroll(): void {
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));

    if (!id || !document.getElementById(id)) {
      return;
    }

    void scrollToSection(id);
  }, []);
}
